import { Order } from '../../proto/generated/order'
import { getPlacedOrder } from '../../services/apis/orders'
import type { OrderPreviewLeg } from './domains/tradingDomain'

/**
 * Draco saves a bracket's stop/target (and later iceberg legs) as deferred rows without pushing
 * them to the browser; Quick Trade shows them from its own place response. An AI confirm's place
 * response stays in Scorpius, so fetch the legs the orders list hasn't seen.
 */
export async function fetchUnseenLegOrders(
    legs: OrderPreviewLeg[] | null | undefined,
    knownOrderIds: ReadonlySet<string>,
    accountId: string | undefined,
): Promise<Order[]> {
    if (!accountId || !legs?.length) return []
    const orderIds = legs
        .map((leg) => leg.orderId)
        .filter((id): id is string => Boolean(id) && !knownOrderIds.has(id as string))
    const results = await Promise.allSettled(
        orderIds.map((orderId) => getPlacedOrder({ accountId, orderId })),
    )
    return results.flatMap((result) => (result.status === 'fulfilled' ? [result.value] : []))
}
